import { CategoryTag, CategoryTrigger, DesktopNavMenu as DesktopNavMenuBase, MaybeLink, NavItemRichContent, NextImage, } from "@jog/react-components";
const SubCategoryItem = ({ item }) => {
    const style = { "--text-color": item.subCategoryTextColor || "inherit" };
    return (<div>
            <MaybeLink gtm={true} className="flex items-center leading-5" style={style} href={item.subCategoryUrl}>
                <div className="text-sm font-medium text-[var(--text-color)]">
                    <NavItemRichContent htmlStr={item.subCategoryName}/>
                </div>
                <CategoryTag className="text-13" label={item.subLabelText} color={item.subLabelTextColor || ""} backgroundColor={item.subLabelBgColor || ""}/>
            </MaybeLink>
            <div className="mt-2.5 space-y-2">
                {item.thirdCategoryItems.map((child, index) => (<ThirdCategoryItem key={index} item={child}/>))}
            </div>
        </div>);
};
const ThirdCategoryItem = ({ item }) => {
    const style = { "--text-color": item.thirdCategoryTextColor || "inherit" };
    return (<MaybeLink gtm={true} className="flex items-center text-base leading-normal" href={item.thirdCategoryUrl} style={style}>
            <div className="text-[var(--text-color)] hover:text-red-main">
                <NavItemRichContent htmlStr={item.thirdCategoryName}/>
            </div>
            <CategoryTag className="text-13" label={item.thirdLabelText} color={item.thirdLabelTextColor || ""} backgroundColor={item.thirdLabelBgColor || ""}/>
        </MaybeLink>);
};
export const DesktopNavMenu = () => (<DesktopNavMenuBase Trigger={({ navItem }) => <CategoryTrigger className="h-10 text-sm font-semibold" navItem={navItem}/>} MenuContent={({ navItem }) => (<div className="grid grid-cols-5 gap-x-1 p-5">
                {navItem.subCategoryItems.map((child, index) => (<SubCategoryItem key={index} item={child}/>))}
                {(navItem === null || navItem === void 0 ? void 0 : navItem.bannerImage) ? (<MaybeLink gtm={true} href={navItem.bannerUrl}>
                        <NextImage blur={false} width={300} height={300} quality={100} src={navItem.bannerImage} alt="Category navigation banner"/>
                        <span className="sr-only">Category navigation banner</span>
                    </MaybeLink>) : (<></>)}
            </div>)}/>);
